import { Injectable, computed, signal } from '@angular/core';

/**
 * Class-wide lightbox presence — the ONE signal a cross-cutting consumer reads (the article
 * overlay presence home's shape). The anonymous media lightbox mounts per share/portal page, so a
 * per-instance `open` read sees only ITS instance — but the keyboard reference's z ladder must lift
 * over a lightbox from ANY instance (it paints at 1200, above the reference's resting rung, so an
 * un-lifted reference opened over it is invisible under the scrim and still eats the Escape).
 * Every instance reports its open/close transitions here; anyOpen is true while at least one
 * lightbox is up.
 */
@Injectable({ providedIn: 'root' })
export class LightboxPresence {
  private readonly openCount = signal(0);
  readonly anyOpen = computed(() => this.openCount() > 0);

  report(open: boolean): void {
    this.openCount.update(n => Math.max(0, n + (open ? 1 : -1)));
  }
}
